module.exports = __webpack_public_path__ + "static/media/background_pin_light.c836ca33.png";